import styled from 'styled-components';

const Wrapper = styled.div`
	display: flex;
	height: 100%;
	flex-direction: column;
	justify-content: space-between;
`;

const Header = styled.div`
	height: 45px;
	background-color: ${p => p.theme.colors.lightGrey};
	padding: 16px;
	display: flex;
	border-bottom: 1px solid ${p => p.theme.colors.border};
	outline: none;

	@media (max-width: 768px) {
		background-color: ${p => p.theme.colors.white};
		position: fixed;
		bottom: 0;
		width: 100%;
	}
`;

const TopContent = styled.div`
	background-color: ${p => p.theme.colors.white};
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;

	&::-webkit-scrollbar {
		display: none;
	}

	@media (max-width: 768px) {
		overflow: visible;
	}
`;

const Block = styled.div`
	padding: 0 24px 20px;
`;

const SectionTitle = styled.div`
	display: flex;
	justify-content: center;
	margin: 18px 0 30px;
`;

const BottomContent = styled.div`
	height: 92px;
	background-color: ${p => p.theme.colors.lightGrey};
	padding: 23px 16px 20px;
	display: flex;
	border: none;
	border-top: 1px solid ${p => p.theme.colors.border};
	outline: none;

	@media (max-width: 768px) {
		background-color: ${p => p.theme.colors.white};
		border: 1px solid ${p => p.theme.colors.border};
		position: fixed;
		bottom: 0;
		width: 100%;
	}
`;

const Input = styled.input`
	flex: 1;
	margin-right: 12px;
	border: 1px solid ${p => p.theme.colors.border};
	border-radius: 18.5px;
	padding: 14px 5px 14px 24px;
	height: 100%;
	font-size: 16px;
	-webkit-appearance: none;
`;

const btnSize = 50;

const Button = styled.button<{ active: boolean }>`
	background-color: ${p =>
		p.active ? p.theme.colors.green : p.theme.colors.btnTextGrey};
	width: ${btnSize}px;
	height: ${btnSize}px;
	border-radius: ${btnSize / 2}px;
	border-width: 0;

	&:hover {
		cursor: pointer;
	}
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 20px;
`;

const exportedObject = {
	Wrapper,
	Header,
	TopContent,
	Block,
	SectionTitle,
	BottomContent,
	Input,
	Button,
	Close,
};

export default exportedObject;
